// CourseDetailsPage.tsx
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import backarrow from "../assets/images/techbotImages/BackarrowBlack.png";
import "../styles/CourseDetailPageStyles.css";
import calender from "../assets/images/techbotImages/calendar.png";
import info from "../assets/images/techbotImages/info.png";
import Course from "../assets/images/techbotImages/Course.png";
import bonus from "../assets/images/techbotImages/bonus.png";
import hours from "../assets/images/techbotImages/hours.png";
import flexible from "../assets/images/techbotImages/flexible.png";
import instructorImage from "../assets/images/techbotImages/SoumyaGupta.jpeg";
import tickImg from "../assets/images/techbotImages/tick.png";
import chartImg from "../assets/images/techbotImages/chart.png";
import QuesansImg from "../assets/images/techbotImages/quesAns.jpg";
import objectiveIcon from "../assets/images/techbotImages/objective.png";
import conceptIcon from "../assets/images/techbotImages/concepts.png";
import projectIcon from "../assets/images/techbotImages/project.png";
import bonusIcon from "../assets/images/techbotImages/graduation-hat.png";
import defaultIcon from "../assets/images/techbotImages/rocket (1).png";
import leftarrow from "../assets/images/techbotImages/leftArrow.png";
import rightarrow from "../assets/images/techbotImages/rightArrow.png";
import ageImg from "../assets/images/techbotImages/ageImg.png";
import ComingsoonImg from "../assets/images/techbotImages/comingsoon.png";
import calendarIcon from "../assets/images/techbotImages/Course.png";
import clockIcon from "../assets/images/techbotImages/hours.png";
import scheduleIcon from "../assets/images/techbotImages/flexible.png";
import bonusIcons from "../assets/images/techbotImages/bonus.png";
import liveCardImg from "../assets/images/techbotImages/livecardimg.png";

const CourseDetailPage: React.FC = () => {
  const { courseId } = useParams();
  const location = useLocation();
  const { courseData, academyData } = location.state || {};
  //   if (!courseData || !academyData) {
  //     return <div>No course selected. Please go back and choose a course.</div>;
  //   }

  const goBack = () => {
    window.history.back(); // works like your onclick="goBack()"
  };
  const groupedModules = courseData?.is_live_session
    ? [
        {
          week: "Week 1",
          combinedModules: courseData.course_tabs.modules.slice(0, 2), // Week 1 + 2
        },
        {
          week: "Week 2",
          combinedModules: courseData.course_tabs.modules.slice(2), // Week 3 onwards
        },
      ]
    : courseData.course_tabs.modules.map((m: { week: any }) => ({
        week: m.week,
        combinedModules: [m],
      }));

  const getIconForItem = (item: string) => {
    const lower = item.toLowerCase();
    if (lower.startsWith("objective:")) return objectiveIcon;
    if (lower.startsWith("concepts:")) return conceptIcon;
    if (lower.startsWith("project:")) return projectIcon;
    if (lower.startsWith("bonus")) return bonusIcon;
    return defaultIcon;
  };
  const tabs = [
    { key: "about", label: "About" },
    { key: "instructor", label: "Instructor" },
    { key: "benefits", label: "Benefits" },
    { key: "modules", label: "Modules" },
    { key: "prerequisites", label: "Prerequisites" },
    { key: "testimonials", label: "Testimonials" },
  ];

  const testimonials = [
    {
      rating: 5,
      content:
        "Soumya is a teacher par excellence be it electronics or 3d printing. She is able to teach at the student's level. I have found students’ grasping what she has taught very well. I am sure she will go places. I wish her many successes!",
      name: "Sumathi Bhaskar",
    },
    {
      rating: 5,
      content:
        "My son started at level 1 and continued to now level 2. He finds the classes very engaging. He has been tinkering with electronics at home on his own after getting inspired in the class. He says that Soumya madam allows them to figure things out on their own while supporting and this helps in learning better.",
      name: "Ajay Singh Negi",
    },
    {
      rating: 5,
      content:
        "Soumya is very dedicated and hardworking. I sent my son for level 1 and continue for level 2. It was an amazing experience, he developed a lot of interest in circuits, switches, etc., and started exploring and experimenting with many things around it.",
      name: "Abhilasha agrawal",
    },
    {
      rating: 5,
      content:
        "My Daughter started with level 2 and she's enjoying the classes. Unlike other robotics classes here she's learning the science behind rather just putting some things together. She looks forward to Saturdays for her class.",
      name: "Sushma Dev",
    },
  ];
  const scrollRef = useRef<HTMLDivElement>(null);
  const [scrollDir, setScrollDir] = useState<"left" | "right">("right");

  const scroll = (direction: "left" | "right") => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === "right" ? 320 : -320,
        behavior: "smooth",
      });
    }
  };

  const updateScrollDirection = () => {
    if (!scrollRef.current) return;

    const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;

    // If at right end, reverse to left
    if (scrollLeft + clientWidth >= scrollWidth - 10) {
      setScrollDir("left");
    }
    // If at left end, reverse to right
    else if (scrollLeft <= 10) {
      setScrollDir("right");
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      scroll(scrollDir);
      updateScrollDirection();
    }, 4000);

    return () => clearInterval(interval);
  }, [scrollDir]);

  // Manual scroll should also update direction
  const handleManualScroll = (direction: "left" | "right") => {
    scroll(direction);
    setScrollDir(direction); // optional: align auto-scroll with manual
  };
  const [activeTab, setActiveTab] = useState("about");
  const tabsRef = useRef<(HTMLDivElement | null)[]>([]);
  const [indicatorStyle, setIndicatorStyle] = useState({ left: 0, width: 0 });

  useEffect(() => {
    const activeIndex = tabs.findIndex((tab) => tab.key === activeTab);
    const activeTabEl = tabsRef.current[activeIndex];

    if (activeTabEl) {
      const { offsetLeft, offsetWidth } = activeTabEl;
      setIndicatorStyle({ left: offsetLeft, width: offsetWidth });
    }
  }, [activeTab]);
  const getIconImage = (title: string) => {
    const lowerTitle = title.toLowerCase();

    if (lowerTitle.includes("week")) return calendarIcon;
    if (lowerTitle.includes("bonus")) return bonusIcons;
    if (lowerTitle.includes("hour")) return clockIcon;
    if (lowerTitle.includes("schedule")) return scheduleIcon;
    if (lowerTitle.includes("live")) return liveCardImg;

    return ""; // fallback icon if nothing matches
  };

  const items = [
    {
      icon: Course, // Replace with your actual icon path
      title: "4 Weeks Course Series",
    },
    {
      icon: bonus,
      title: "1 Bonus Challenge",
    },
    {
      icon: hours,
      title: "3.5 Hours Content",
    },
    {
      icon: flexible,
      title: "Flexible Schedule",
      subtitle: "Learn at your own pace",
    },
  ];

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#D2ECFF",
        height: "90vh",
        overflowY: "auto",
      }}
    >
      {" "}
      <div className="techBotTopSection">
        <div className="techBotHeader">
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              onClick={goBack}
              src={backarrow}
              alt="Techbot Icon"
              className="techBotLogo"
              style={{
                marginRight: "10px",
                width: "40px",
                height: "20px",
                cursor: "pointer",
              }}
            />
            <div className="techBotHeaderTitle">
              <h1 style={{ marginBottom: 0 }}>TechBots Academy</h1>
              <p style={{ marginBottom: 0 }}>Mind works best outside the box</p>
            </div>
          </div>
        </div>
      </div>
      <br></br>
      <div className="course-header-container">
        <div className="course-title-section">
          <h2 className="course-title">{courseData.course_title}</h2>
          <p className="course-subtitle">{courseData.course_description} </p>
        </div>
        <button className="techbot-start-button">Start Learning</button>
      </div>
      <br></br>
      <div className="techBotDetailRow" style={{ marginBottom: "10px" }}>
        <div className="row-item">
          <img src={ageImg} alt="Calendar Icon" className="info-img" />
          <div className="info-text">
            <p>Age Criteria: {courseData.age_criteria}</p>
          </div>
        </div>
      </div>
      {courseData?.batch_timings?.length > 0 ? (
        <div className="techBotDetailRow" style={{ marginBottom: "0px" }}>
          <div className="row-item">
            <img src={calender} alt="Calendar Icon" className="info-img" />
            <div className="info-text">
              <p style={{ marginTop: "3px" }}>Batch Timings:</p>
            </div>
          </div>
        </div>
      ) : (
        <div className="techBotDetailRow" style={{ marginBottom: "0px" }}>
          <div className="row-item">
            <img src={ComingsoonImg} alt="Calendar Icon" className="info-img" />
            <div className="info-text">
              <span className="batch-full-tag" style={{ paddingBottom: "2px" }}>
                COMING SOON
              </span>
            </div>
          </div>
        </div>
      )}
      {courseData?.batch_timings?.length > 0 && (
        <div className="techBotDetailRow">
          <div className="row-item" style={{ marginLeft: "25px" }}>
            <div className="info-text">
              <div className="batch-list">
                {courseData.batch_timings.map(
                  (
                    batch: {
                      course_duration:
                        | string
                        | number
                        | boolean
                        | React.ReactElement<
                            any,
                            string | React.JSXElementConstructor<any>
                          >
                        | Iterable<React.ReactNode>
                        | React.ReactPortal
                        | null
                        | undefined;
                      registration_enddate:
                        | string
                        | number
                        | boolean
                        | React.ReactElement<
                            any,
                            string | React.JSXElementConstructor<any>
                          >
                        | Iterable<React.ReactNode>
                        | React.ReactPortal
                        | null
                        | undefined;
                    },
                    index: React.Key | null | undefined,
                  ) => (
                    <div key={index} className="batch-line">
                      <span>{batch.course_duration}</span>
                      {batch.registration_enddate ? (
                        <span
                          className="reg-info"
                          style={{ marginLeft: "5px" }}
                        >
                          <img
                            src={info}
                            alt="Calendar Icon"
                            className="info-img"
                          />
                          {batch.registration_enddate}
                        </span>
                      ) : (
                        <span className="batch-full-tag">Batch Full</span>
                      )}
                    </div>
                  ),
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      <br></br>
      {/* Highlight Cards */}
      <div className="highlight-container">
        {courseData.course_highlight.map(
          (
            item: {
              icon: any;
              title:
                | string
                | number
                | boolean
                | React.ReactElement<
                    any,
                    string | React.JSXElementConstructor<any>
                  >
                | Iterable<React.ReactNode>
                | React.ReactPortal
                | null
                | undefined;
              subtitle:
                | string
                | number
                | boolean
                | React.ReactElement<
                    any,
                    string | React.JSXElementConstructor<any>
                  >
                | Iterable<React.ReactNode>
                | React.ReactPortal
                | null
                | undefined;
            },
            index: React.Key | null | undefined,
          ) => (
            <div key={index} className="highlight-card">
              <img
                src={getIconImage(item.title as string)}
                alt="icon"
                className="card-icon"
              />
              <div className="text-group">
                <p style={{ fontSize: "14px" }}>{item.title}</p>
                {item.subtitle && (
                  <p className="card-subtitle">{item.subtitle}</p>
                )}
              </div>
            </div>
          ),
        )}
      </div>
      <div className="tab-navigation">
        <div className="tabs">
          {tabs.map((tab, index) => (
            <div
              key={tab.key}
              ref={(el) => (tabsRef.current[index] = el)}
              className={`tabsLabel ${activeTab === tab.key ? "active" : ""}`} // ✅ Apply this
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </div>
          ))}
          <div className="tab-indicator" style={indicatorStyle} />
        </div>
      </div>
      <div className="tab-content">
        {tabs.map((tab) => (
          <div
            key={tab.key}
            className={`tab-panel ${activeTab === tab.key ? "active" : ""}`}
          >
            {tab.key === "about" && courseData?.course_tabs?.about && (
              <div className="about-tab-content-row">
                <div className="about-text-content">
                  <p className="about-description">
                    {courseData.course_tabs.about.about_content1
                      .split("\n")
                      .map(
                        (
                          line:
                            | string
                            | number
                            | boolean
                            | React.ReactElement<
                                any,
                                string | React.JSXElementConstructor<any>
                              >
                            | Iterable<React.ReactNode>
                            | React.ReactPortal
                            | null
                            | undefined,
                          index: React.Key | null | undefined,
                        ) => (
                          <React.Fragment key={index}>
                            {line}
                            <br />
                          </React.Fragment>
                        ),
                      )}
                  </p>

                  <div className="highlight-aboutcontainer">
                    {courseData.course_tabs.about.key_takeaways.map(
                      (
                        item:
                          | string
                          | number
                          | boolean
                          | React.ReactElement<
                              any,
                              string | React.JSXElementConstructor<any>
                            >
                          | Iterable<React.ReactNode>
                          | React.ReactPortal
                          | null
                          | undefined,
                        index: React.Key | null | undefined,
                      ) => (
                        <div className="highlight-pill">{item}</div>
                      ),
                    )}
                  </div>
                  <p
                    className="about-description"
                    style={{ marginTop: "16px" }}
                  >
                    {courseData.course_tabs.about.about_content2}
                  </p>
                </div>

                <div className="about-video-content">
                  {courseData.course_tabs.about.course_video && (
                    <div className="about-video">
                      <iframe
                        width="100%"
                        height="300"
                        src={courseData.course_tabs.about.course_video}
                        title="Course Video"
                        frameBorder="0"
                        allowFullScreen
                      ></iframe>
                    </div>
                  )}
                </div>
              </div>
            )}
            {tab.key === "instructor" && (
              <div className="instructor-tab-content">
                <h3>About Instructor</h3>
                <div className="instructor-info">
                  <img
                    src={instructorImage}
                    alt="sowmya"
                    className="instructor-photo"
                  />
                  <div className="instructor-details">
                    <p>
                      <strong className="instructornmae">Soumya Gupta,</strong>
                    </p>
                    <p className="instructordesc">
                      With 18 years in software development and Program
                      management, I, Soumya Gupta, specialize in full-stack
                      development, best coding practices, and mentoring future
                      tech leaders. After attending an AI and ML course online
                      from IIIT Bengaluru, I founded TechBots Academy. The
                      learning journey here begins with Robotics and leads to
                      AI. With real-world analogies and examples, we keep things
                      interesting and informative. The vision is to learn AI
                      gamified with robotics, empowering them with future-ready
                      tech skills!
                    </p>
                    <br></br>
                    <p className="instructor-details">
                      Contact details:
                      <strong> +91-98453 48122 </strong>
                    </p>
                  </div>
                </div>
              </div>
            )}
            {tab.key === "benefits" && courseData?.course_tabs?.benefits && (
              <div className="benefits-tab-content">
                <div className="benefits-columns">
                  {/* Left Column: Science & Engineering */}
                  <div className="benefits-section">
                    <h4>Science & Engineering Concepts:</h4>
                    <ul className="benefit-list">
                      {courseData.course_tabs.benefits.science_engineering_concepts.map(
                        (
                          item:
                            | string
                            | number
                            | boolean
                            | React.ReactElement<
                                any,
                                string | React.JSXElementConstructor<any>
                              >
                            | Iterable<React.ReactNode>
                            | React.ReactPortal
                            | null
                            | undefined,
                          index: React.Key | null | undefined,
                        ) => (
                          <li key={index}>
                            <img
                              src={tickImg}
                              alt="tick"
                              className="tickIcon"
                            />
                            {typeof item === "string" && item.includes(":")
                              ? (() => {
                                  const [boldText, normalText] =
                                    item.split(":");
                                  return (
                                    <>
                                      <strong>{boldText.trim()}:</strong>{" "}
                                      {normalText.trim()}
                                    </>
                                  );
                                })()
                              : item}
                          </li>
                        ),
                      )}
                    </ul>
                  </div>

                  {/* Middle Column: Future-Ready Learning */}
                  <div className="benefits-section">
                    <h4>Future-Ready Learning:</h4>
                    <ul className="benefit-list">
                      {courseData.course_tabs.benefits.future_ready_learning.map(
                        (
                          item:
                            | string
                            | number
                            | boolean
                            | React.ReactElement<
                                any,
                                string | React.JSXElementConstructor<any>
                              >
                            | Iterable<React.ReactNode>
                            | React.ReactPortal
                            | null
                            | undefined,
                          index: React.Key | null | undefined,
                        ) => (
                          <li key={index}>
                            <img
                              src={tickImg}
                              alt="tick"
                              className="tickIcon"
                            />
                            {typeof item === "string" && item.includes(":")
                              ? (() => {
                                  const [boldText, normalText] =
                                    item.split(":");
                                  return (
                                    <>
                                      <strong>{boldText.trim()}:</strong>{" "}
                                      {normalText.trim()}
                                    </>
                                  );
                                })()
                              : item}
                          </li>
                        ),
                      )}
                    </ul>
                  </div>

                  {/* Right Column: Skill Evaluation Image */}
                  <div className="skill-eval-section">
                    <h4>Personalized Skill Evaluation</h4>
                    <img
                      src={chartImg}
                      alt="Skill Evaluation"
                      className="skill-eval-image"
                    />
                    <img
                      style={{ paddingTop: "10px" }}
                      src={QuesansImg}
                      alt="Skill Evaluation"
                      className="skill-eval-image"
                    />
                  </div>
                </div>
              </div>
            )}
            {tab.key === "modules" &&
              courseData?.course_tabs?.modules &&
              Array.isArray(courseData.course_tabs.modules) &&
              (courseData.is_live_session ? (
                <div className="modules-tab-content">
                  {/* Card for Week 1 & Week 2 */}
                  <div className="module-card live-card w-full md:w-1/2">
                    <h2
                      style={{
                        fontFamily: "Mazzard",
                        fontSize: "20px",
                        fontWeight: "600",
                      }}
                    >
                      Week 1
                    </h2>
                    {[0, 1].map((weekIndex) => {
                      const module = courseData.course_tabs.modules[weekIndex];
                      return (
                        <div key={weekIndex}>
                          <h3>{module.title}</h3>
                          <ul className="module-items list-none">
                            {module.items.map(
                              (
                                item: {
                                  label:
                                    | string
                                    | number
                                    | boolean
                                    | React.ReactElement<
                                        any,
                                        | string
                                        | React.JSXElementConstructor<any>
                                      >
                                    | Iterable<React.ReactNode>
                                    | null
                                    | undefined;
                                  subtext: string[];
                                },
                                idx: React.Key | null | undefined,
                              ) => {
                                const label =
                                  typeof item.label === "string"
                                    ? item.label.toLowerCase()
                                    : "";
                                let icon = defaultIcon;

                                if (label.startsWith("objective"))
                                  icon = objectiveIcon;
                                else if (label.startsWith("concepts"))
                                  icon = conceptIcon;
                                else if (label.startsWith("project"))
                                  icon = projectIcon;
                                else if (label.startsWith("bonus"))
                                  icon = bonusIcon;

                                return (
                                  <li key={idx} className="module-item">
                                    <img
                                      src={icon}
                                      alt="icon"
                                      className="module-icon"
                                    />
                                    <div>
                                      <span className="main-label">
                                        {item.label}
                                      </span>
                                      {item.subtext?.length > 0 && (
                                        <div className="subtext-list ml-4 mt-1">
                                          {item.subtext.map(
                                            (point: string, pIdx: number) => (
                                              <div
                                                key={pIdx}
                                                className="text-sm flex items-start gap-1"
                                              >
                                                <img
                                                  src={tickImg}
                                                  alt="tick"
                                                  className="tickIcon"
                                                />
                                                <span>{point}</span>
                                              </div>
                                            ),
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </li>
                                );
                              },
                            )}
                          </ul>
                        </div>
                      );
                    })}
                  </div>

                  {/* Card for remaining weeks (Week 3 and beyond) */}
                  <div className="module-card live-card w-full md:w-1/2">
                    <h2
                      style={{
                        fontFamily: "Mazzard",
                        fontSize: "20px",
                        fontWeight: "600",
                      }}
                    >
                      Week 2
                    </h2>
                    {courseData.course_tabs.modules.slice(2).map(
                      (
                        module: {
                          week:
                            | string
                            | number
                            | boolean
                            | React.ReactElement<
                                any,
                                string | React.JSXElementConstructor<any>
                              >
                            | Iterable<React.ReactNode>
                            | React.ReactPortal
                            | null
                            | undefined;
                          title:
                            | string
                            | number
                            | boolean
                            | React.ReactElement<
                                any,
                                string | React.JSXElementConstructor<any>
                              >
                            | Iterable<React.ReactNode>
                            | React.ReactPortal
                            | null
                            | undefined;
                          items: any[];
                        },
                        index: number,
                      ) => (
                        <div key={index + 2}>
                          <h3>{module.title}</h3>
                          <ul className="module-items list-none">
                            {module.items.map((item, idx) => {
                              const label = item.label?.toLowerCase?.() || "";
                              let icon = defaultIcon;

                              if (label.startsWith("objective"))
                                icon = objectiveIcon;
                              else if (label.startsWith("concepts"))
                                icon = conceptIcon;
                              else if (label.startsWith("project"))
                                icon = projectIcon;
                              else if (label.startsWith("bonus"))
                                icon = bonusIcon;

                              return (
                                <li key={idx} className="module-item">
                                  <img
                                    src={icon}
                                    alt="icon"
                                    className="module-icon"
                                  />
                                  <div>
                                    <span className="main-label">
                                      {item.label}
                                    </span>
                                    {item.subtext?.length > 0 && (
                                      <div className="subtext-list ml-4 mt-1">
                                        {item.subtext.map(
                                          (point: string, pIdx: number) => (
                                            <div
                                              key={pIdx}
                                              className="text-sm flex items-start gap-1"
                                            >
                                              <img
                                                src={tickImg}
                                                alt="tick"
                                                className="tickIcon"
                                              />
                                              <span>{point}</span>
                                            </div>
                                          ),
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      ),
                    )}
                  </div>
                </div>
              ) : (
                // Fallback to normal UI if not live
                <div className="modules-tab-content">
                  <div className="module-cards-container">
                    {courseData.course_tabs.modules.map(
                      (
                        module: {
                          week:
                            | string
                            | number
                            | boolean
                            | React.ReactElement<
                                any,
                                string | React.JSXElementConstructor<any>
                              >
                            | Iterable<React.ReactNode>
                            | React.ReactPortal
                            | null
                            | undefined;
                          title:
                            | string
                            | number
                            | boolean
                            | React.ReactElement<
                                any,
                                string | React.JSXElementConstructor<any>
                              >
                            | Iterable<React.ReactNode>
                            | React.ReactPortal
                            | null
                            | undefined;
                          items: any[];
                        },
                        index: React.Key | null | undefined,
                      ) => (
                        <div key={index} className="module-card">
                          <h3>
                            {module.week}: {module.title}
                          </h3>
                          <ul className="module-items list-none">
                            {module.items.map((item, idx) => {
                              const label = item.label?.toLowerCase?.() || "";
                              let icon = defaultIcon;

                              if (label.startsWith("objective"))
                                icon = objectiveIcon;
                              else if (label.startsWith("concepts"))
                                icon = conceptIcon;
                              else if (label.startsWith("project"))
                                icon = projectIcon;
                              else if (label.startsWith("bonus"))
                                icon = bonusIcon;

                              return (
                                <li key={idx} className="module-item">
                                  <img
                                    src={icon}
                                    alt="icon"
                                    className="module-icon"
                                  />
                                  <div>
                                    <span className="main-label">
                                      {item.label}
                                    </span>
                                    {item.subtext?.length > 0 && (
                                      <div className="subtext-list ml-4 mt-1">
                                        {item.subtext.map(
                                          (point: string, pIdx: number) => (
                                            <div
                                              key={pIdx}
                                              className="text-sm flex items-start gap-1"
                                            >
                                              <img
                                                src={tickImg}
                                                alt="tick"
                                                className="tickIcon"
                                              />
                                              <span>{point}</span>
                                            </div>
                                          ),
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      ),
                    )}
                  </div>
                </div>
              ))}

            {tab.key === "prerequisites" &&
              courseData?.course_tabs?.prerequisites && (
                <div className="about-tab-content-row">
                  <div className="about-text-content">
                    <p className="about-description">
                      <strong>Hardware Requirements:</strong>{" "}
                    </p>

                    <ul className="benefit-list">
                      {courseData.course_tabs.prerequisites.hardware.map(
                        (
                          item:
                            | string
                            | number
                            | boolean
                            | React.ReactElement<
                                any,
                                string | React.JSXElementConstructor<any>
                              >
                            | Iterable<React.ReactNode>
                            | React.ReactPortal
                            | null
                            | undefined,
                          index: React.Key | null | undefined,
                        ) => (
                          <li key={index}>
                            <img
                              src={tickImg}
                              alt="tick"
                              className="tickIcon"
                            />
                            {typeof item === "string" && item.includes(":")
                              ? (() => {
                                  const [boldText, normalText] =
                                    item.split(":");
                                  return (
                                    <>
                                      <strong>{boldText.trim()}:</strong>{" "}
                                      {normalText.trim()}
                                    </>
                                  );
                                })()
                              : item}
                          </li>
                        ),
                      )}
                    </ul>
                    <p className="about-description">
                      {" "}
                      <strong>Software Requirements:</strong>
                    </p>
                    <div className="highlight-aboutcontainer">
                      {courseData.course_tabs.prerequisites.software.map(
                        (item: any, index: React.Key | null | undefined) => {
                          const text = String(item);

                          if (text.includes("Arduino IDE")) {
                            const [before, after] = text.split("Arduino IDE");
                            return (
                              <div key={index} className="highlight-pill">
                                {before}
                                <a
                                  href="https://support.arduino.cc/hc/en-us/articles/360019833020-Download-and-install-Arduino-IDE"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-blue-600 underline"
                                >
                                  Arduino IDE
                                </a>
                                {after}
                              </div>
                            );
                          } else if (text.includes("Tinkercad login")) {
                            const [before, after] =
                              text.split("Tinkercad login");
                            return (
                              <div key={index} className="highlight-pill">
                                {before}
                                <a
                                  href="https://www.tinkercad.com/"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-blue-600 underline"
                                >
                                  Tinkercad login
                                </a>
                                {after}
                              </div>
                            );
                          } else {
                            return (
                              <div key={index} className="highlight-pill">
                                {text}
                              </div>
                            );
                          }
                        },
                      )}
                    </div>
                  </div>

                  <div className="about-video-content">
                    {courseData.course_tabs.about.course_video && (
                      <div className="about-video">
                        <iframe
                          width="100%"
                          height="300"
                          src="https://www.youtube.com/embed/videoseries?si=39aaYDhrs8UUt_GH&amp;list=PLY_kTx_mOTOg1_iK4X23tgk3CUGnF4j0Z"
                          title="Course Video"
                          frameBorder="0"
                          allowFullScreen
                        ></iframe>
                      </div>
                    )}
                  </div>
                </div>
              )}
            {tab.key === "testimonials" && (
              <div className="testimonial-wrapper">
                <img
                  src={leftarrow}
                  alt="icon"
                  onClick={() => handleManualScroll("left")}
                  className="arrow"
                />

                <div className="testimonial-container" ref={scrollRef}>
                  {testimonials.map((testimonial, index) => (
                    <div key={index} className="testimonial-card">
                      <div className="testimonial-stars">
                        {"★".repeat(testimonial.rating)}
                        {"☆".repeat(5 - testimonial.rating)}
                      </div>
                      <p className="testimonial-text">
                        "{testimonial.content}"
                      </p>
                      <div className="testimonial-author">
                        <div className="testimonial-avatar">
                          {testimonial.name.charAt(0).toUpperCase()}
                        </div>
                        <span className="testimonial-name">
                          {testimonial.name}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>

                <img
                  src={rightarrow}
                  alt="icon"
                  onClick={() => handleManualScroll("right")}
                  className="arrow"
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const InfoCard = ({ title, subtitle }: { title: string; subtitle: string }) => (
  <div className="p-3 bg-white rounded shadow">
    <h4 className="font-semibold text-blue-800">{title}</h4>
    <p className="text-xs text-gray-600">{subtitle}</p>
  </div>
);

export default CourseDetailPage;
